import gql from 'graphql-tag'
import apolloClient from 'shared/apolloClient'
import { LOG_LEVELS } from 'constants/values'

const LOG_MESSAGE = gql`
  mutation logMessage($request: LogMessageType!) {
    logMessage(request: $request)
  }
`

const LOG_DETAILS = gql`
  mutation logDetails($request: LogDetailInput!) {
    logDetails(request: $request)
  }
`

export const log = (message, logLevel = LOG_LEVELS.LOG) => {
  apolloClient.mutate({
    mutation: LOG_MESSAGE,
    variables: { request: { message, logLevel } },
  })
}

export const logDetails = (details, logLevel = LOG_LEVELS.LOG) => {
  const { message, data } = details
  apolloClient.mutate({
    mutation: LOG_DETAILS,
    variables: {
      request: { details: { message, data: JSON.stringify(data) }, logLevel },
    },
  })
}

const reportedValidationFailures = new Set()

// Yup type errors embed the final value and, when cast, the original input
// ("... final value was: `x` (cast from the value `y`).") e.g. a date of birth.
// Everything after each marker is dropped, so values containing backticks are safe.
const redactValues = message =>
  String(message)
    .replace(/(value was:?).*$/is, '$1 `[redacted]`')
    .replace(/(cast from the value).*$/is, '$1 `[redacted]`')

// Only field names and validation messages are logged, never field values (PII).
// Each distinct form + failing fields combination is logged once per page load.
export const logFormValidationErrors = (formName, errors, context = {}) => {
  const fields = Object.keys(errors || {}).sort()
  if (fields.length === 0) return

  const key = [formName, ...fields].join('|')
  if (reportedValidationFailures.has(key)) return
  reportedValidationFailures.add(key)

  const messages = fields.reduce(
    (acc, field) => ({ ...acc, [field]: redactValues(errors[field]) }),
    {}
  )

  // Diagnostic only: a failure here must never redirect or interrupt the customer,
  // so the global Apollo error link is told to ignore this operation.
  try {
    const request = {
      details: {
        message: `${formName} validation failed on fields not visible to the user`,
        data: JSON.stringify({ form: formName, fields, messages, ...context }),
      },
      logLevel: LOG_LEVELS.WARN,
    }
    Promise.resolve(
      apolloClient.mutate({
        mutation: LOG_DETAILS,
        variables: { request },
        context: { skipErrorHandling: true },
      })
    ).catch(() => {})
  } catch (e) {
    // intentionally ignored
  }
}
